import { getFacilitiesColumns } from '@/features/_columns/facilities-table-column'
import { LoadingDataTable } from '@/features/_components/loading-data-table'

export const FacilitiesTableSkeleton = () => {
  return <LoadingDataTable columns={getFacilitiesColumns('')} />
}
